"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroTextContent = void 0;
const languageUtils_1 = require("../languageUtils");
const devbutton_png_1 = __importDefault(require("../../img/hero/devbutton.png"));
const devbutton_nl_png_1 = __importDefault(require("../../img/hero/devbutton_nl.png"));
const devbutton_pt_png_1 = __importDefault(require("../../img/hero/devbutton_pt.png"));
const devbutton_de_png_1 = __importDefault(require("../../img/hero/devbutton_de.png"));
const devbutton_fr_png_1 = __importDefault(require("../../img/hero/devbutton_fr.png"));
const devbutton_it_png_1 = __importDefault(require("../../img/hero/devbutton_it.png"));
const devbutton_es_png_1 = __importDefault(require("../../img/hero/devbutton_es.png"));
const demo_btn_png_1 = __importDefault(require("../../img/hero/demo_btn.png"));
const demo_btn_de_png_1 = __importDefault(require("../../img/hero/demo_btn_de.png"));
const demo_btn_es_png_1 = __importDefault(require("../../img/hero/demo_btn_es.png"));
const demo_btn_fr_png_1 = __importDefault(require("../../img/hero/demo_btn_fr.png"));
const demo_btn_it_png_1 = __importDefault(require("../../img/hero/demo_btn_it.png"));
const demo_btn_nl_png_1 = __importDefault(require("../../img/hero/demo_btn_nl.png"));
const demo_btn_pt_png_1 = __importDefault(require("../../img/hero/demo_btn_pt.png"));
// NOTE: Record<keys, values>
const heroText = {
    en: {
        callout: '',
        date: 'September 5, 2025',
        // preorder: 'pre-order now',
        preorder: 'Available Now',
        btnDevHref: 'https://www.youtube.com/watch?v=WDWIvQgC41w?autoplay=1',
        btnDevSrc: devbutton_png_1.default,
        btnDemo: demo_btn_png_1.default,
    },
    ca: {
        callout: '',
        date: 'September 5, 2025',
        // preorder: 'pre-order now',
        preorder: 'Available Now',
        btnDevHref: 'https://www.youtube.com/watch?v=WDWIvQgC41w?autoplay=1',
        btnDevSrc: devbutton_png_1.default,
        btnDemo: demo_btn_png_1.default,
    },
    uk: {
        callout: '',
        date: 'September 5, 2025',
        // preorder: 'pre-order now',
        preorder: 'Available Now',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_png_1.default,
        btnDemo: demo_btn_png_1.default,
    },
    au: {
        callout: '',
        date: 'September 5, 2025',
        // preorder: 'pre-order now',
        preorder: 'Available Now',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_png_1.default,
        btnDemo: demo_btn_png_1.default,
    },
    nz: {
        callout: '',
        date: 'September 5, 2025',
        // preorder: 'pre-order now',
        preorder: 'Available Now',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_png_1.default,
        btnDemo: demo_btn_png_1.default,
    },
    fr: {
        callout: '',
        date: '5 Septembre 2025',
        // preorder: 'Précommander maintenant',
        preorder: 'Maintenant disponible',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_fr_png_1.default,
        btnDemo: demo_btn_fr_png_1.default,
    },
    de: {
        callout: '',
        date: '5 September 2025',
        // preorder: 'Jetzt vorbestellen',
        preorder: 'Jetzt Erhältlich',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_de_png_1.default,
        btnDemo: demo_btn_de_png_1.default,
    },
    es: {
        callout: '',
        date: '5 Septiembre 2025',
        // preorder: 'Reservar ahora',
        preorder: 'Ya Disponible',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_es_png_1.default,
        btnDemo: demo_btn_es_png_1.default,
    },
    it: {
        callout: '',
        date: '5 Settembre 2025',
        // preorder: 'Preordina ora',
        preorder: 'Ora disponibile',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_it_png_1.default,
        btnDemo: demo_btn_it_png_1.default,
    },
    pt: {
        callout: '',
        date: '5 Setembro 2025',
        // preorder: 'Pré-encomenda agora',
        preorder: 'Já disponível',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_pt_png_1.default,
        btnDemo: demo_btn_pt_png_1.default,
    },
    nl: {
        callout: '',
        date: '5 September 2025',
        // preorder: 'Nu vooruitbestellen',
        preorder: 'Nu verkrijgbaar',
        btnDevHref: 'https://www.youtube.com/watch?v=uXYJFg5DWlE?autoplay=1',
        btnDevSrc: devbutton_nl_png_1.default,
        btnDemo: demo_btn_nl_png_1.default,
    },
};
class HeroTextContent {
    constructor() {
        this.callout = document.querySelector('.hero__callout');
        this.date = document.querySelector('.hero__date');
        this.preorder = document.querySelector('.hero__preorder');
        this.btnDevHref = document.querySelector('.btn__dev__href');
        this.btnDevSrc = document.querySelector('.btn__dev');
        this.btnDemo = document.querySelectorAll('.demoBtn');
        this.init();
    }
    init() {
        this.updateText();
    }
    updateText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = heroText[language] || heroText['en'];
        if (this.callout)
            this.callout.textContent = content.callout.toUpperCase();
        // if (this.date) this.date.textContent = content.date.toUpperCase();
        if (this.preorder)
            this.preorder.textContent = content.preorder.toUpperCase();
        if (this.btnDevHref)
            this.btnDevHref.href = content.btnDevHref;
        if (this.btnDevSrc)
            this.btnDevSrc.src = content.btnDevSrc;
        if (this.btnDemo)
            this.btnDemo.forEach(btn => {
                btn.src = content.btnDemo;
            });
    }
}
exports.HeroTextContent = HeroTextContent;
